import * as api from "../Api";
export const receivingBranchData = () => async (dispatch) => {
  try {
    const { data } = await api.getAllSpecificReceivingAdvice();
    dispatch({ type: "GET_ALL_RECEIVING_ADVICE", payload: data });
  } catch (error) {}
};
